import MedicalQuestionnaireFlow from '../components/MedicalQuestionnaireFlow';

export default function MedicalQuestionnaireQuestionsPage() {
  return <MedicalQuestionnaireFlow />;
}
